export default __webpack_public_path__ + "static/media/ISEO_CLASS-3_SYLLABUS_2025-26.2dda6697.pdf";